/* eslint-disable no-undef */
import React, { useState, useContext, useCallback, useEffect } from 'react';
import Cookies from 'js-cookie';
import {
  getDefaultApp,
  getLoginDetails,
  getSenderNames,
  getUserById,
  getUserId,
  getUserwebActivity,
} from './client/client';

const attempts = getLoginDetails();
const defaultApp = getDefaultApp();

const defaultOptions = {
  attempts,
  smsGoal: false,
  defaultApp,
};
export const UnifiedContext = React.createContext();

const getInitialCustomerState = () => {
  const selectedCustomer = sessionStorage.getItem('selectedCustomer');
  return selectedCustomer ? JSON.parse(selectedCustomer) : null;
};
const getInitialTemplateState = () => {
  const selectedWhatsAppTemplate = sessionStorage.getItem(
    'selectedWhatsAppTemplate'
  );
  return selectedWhatsAppTemplate ? JSON.parse(selectedWhatsAppTemplate) : null;
};
export const UnifiedProvider = ({ children, engage, authorized }) => {
  const [selectedWhatsAppTemplate, setSelectedWhatsAppTemplate] = useState(
    getInitialTemplateState
  );
  const [selectedCustomer, setSelectedCustomer] = useState(
    getInitialCustomerState
  );
  useEffect(() => {
    sessionStorage.setItem(
      'selectedCustomer',
      JSON.stringify(selectedCustomer)
    );
  }, [selectedCustomer]);
  useEffect(() => {
    sessionStorage.setItem(
      'selectedWhatsAppTemplate',
      JSON.stringify(selectedWhatsAppTemplate)
    );
  }, [selectedWhatsAppTemplate]);
  const [currentOptions, setCurrentOptions] = useState(
    engage || defaultOptions
  );
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [sendername, setSenderName] = useState();
  const [lastPurchase, setLastPurchase] = useState();
  const [isLoading, setLoading] = useState(false);
  const [activeApp, setActiveApp] = useState(0);

  const [user, setUser] = useState();

  const onboarding = Cookies.get('onboarding');
  const saveOption = (values) => {
    setLoading(true);
    setCurrentOptions(values);
    setLoading(false);
  };

  const refresh = useCallback(
    () => setShouldRefresh(!shouldRefresh),
    [shouldRefresh]
  );

  useEffect(() => {
    if (!authorized) return undefined;
    let cancelled = false;
    const fetchUser = async () => {
      try {
        setLoading(true);
        const response = await getUserById();
        if (!cancelled) setUser(response.data);
      } catch (err) {
        console.error('Failed to fetch user', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchUser();
    return () => {
      cancelled = true;
    };
  }, [refresh]);

  useEffect(() => {
    if (!authorized) return undefined;
    const uid = getUserId();
    if (!uid) return undefined;
    let cancelled = false;
    const fetchSenderNames = async () => {
      try {
        const resp = await getSenderNames({ vendor_id: uid });
        if (!cancelled) setSenderName(resp.data);
      } catch (err) {
        console.error('Failed to fetch sender names', err);
      }
    };
    fetchSenderNames();
    return () => {
      cancelled = true;
    };
  }, [authorized, shouldRefresh]);

  useEffect(() => {
    if (!authorized) return undefined;
    const uid = getUserId();
    if (!uid) return undefined;
    let cancelled = false;
    const fetchActivity = async () => {
      try {
        const resp = await getUserwebActivity({ vendor_id: uid });
        if (!cancelled) setLastPurchase(resp.last_purchase_date);
      } catch (err) {
        console.error('Failed to fetch user web activity', err);
      }
    };
    fetchActivity();
    return () => {
      cancelled = true;
    };
  }, [authorized, shouldRefresh]);

  const isSenderNameActive = () => {
    if (!Array.isArray(sendername) || sendername.length === 0) {
      return false;
    }
    return sendername.some((item) => item.status === 'active');
  };

  return (
    <UnifiedContext.Provider
      value={{
        options: currentOptions,
        saveOption,
        refresh,
        isLoading,
        emgUser: user,
        activeSendername: isSenderNameActive(),
        sendername,
        lastPurchase,
        onboarding,
        setSelectedCustomer,
        setSelectedWhatsAppTemplate,
        selectedWhatsAppTemplate,
        selectedCustomer,
        setActiveApp,
        activeApp,
      }}
    >
      {children}
    </UnifiedContext.Provider>
  );
};

export const unifiedContext = () => useContext(UnifiedContext);
